export const getParam = (paramName: string, search: string) => {
	const params = new URLSearchParams(search);
	return params.get(paramName);
};
